//
//
//
//
//
//
//
//
//
//
//
//
//

import BagSvg from '~/assets/img/bag.svg?inline'

export default {
  name: 'AppHeaderBagIcon',

  components: {
    BagSvg
  },

  computed: {
    bagCount() {
      return this.$store.getters['cart/bagCount']
    }
  }
}
